import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { AreaService } from 'app/service/cliente/area.service';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-numeracao-caixas',
  templateUrl: './numeracao-caixas.component.html',
  styleUrls: ['./numeracao-caixas.component.scss']
})
export class NumeracaoCaixasComponent implements OnInit {
  public clientes: ClienteModel[];
  public areas: any[] = [];
  public subAreas: any[] = [];
  public responsaveis: any[] = [];
  public formularioGerarNumeracao: FormGroup;
  public numerosGerados: any[] = [];
  public showSalvar = false;
  public loading = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  constructor(
    private clienteService: ClienteService,
    private areaService: AreaService,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.listarClientesUsuario();
    this.criarFormulario();
  }

  criarFormulario() {
    this.formularioGerarNumeracao = this.fb.group({
      subAreaId: [null, Validators.required],
      responsavelId: [null, Validators.required],
      qtdNumeros: [null, Validators.required]
    });
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(data => {
      this.clientes = data.content;
    }, err => {
      console.error(err);
    });
  }

  listarAreasCliente(e: any) {
    this.areaService.getAreasUsuarioCliente(e.value.id).subscribe(data => {
      this.areas = data;
    }, err => {
      console.error(err);
    });
  }

  listarSubAreas(e: any) {
    this.areaService.getSubAreaByAreaId(e.value.id).subscribe(data => {
      this.subAreas = data.result;
    }, err => {
      console.error(err);
    });
  }

  showResponsaveis(e: any) {
    this.formularioGerarNumeracao.get('subAreaId').setValue(e.value.id);
    console.log(e);
    this.responsaveis = e.value.responsaveis;
  }

  selectResponsavel(e: any) {
    this.formularioGerarNumeracao.get('responsavelId').setValue(e.value.id);
  }

  gerarNumeracao() {
    console.log(this.formularioGerarNumeracao);
    if (!this.formularioGerarNumeracao.valid) {
      this.openSnackBarError('Formulário com erros.');
      return;
    }
    this.loading = true;
    this.areaService.gerarNumeracao(this.formularioGerarNumeracao.value).subscribe(data => {
        console.log(data);
        this.numerosGerados = data;
        if (data[0] !== 'Subárea atingiu o limite para criação de novos números.') {
          this.imprimir();
        }
        this.formularioGerarNumeracao.get('qtdNumeros').reset();
        this.loading = false;
    }, error => {
      console.error(error);
      this.loading = false;
    });
  
  }

  imprimir() {
    let nrsDownload = '';
    this.numerosGerados.map(element => {
      nrsDownload += element + '\r\n';
    });
    this.download(nrsDownload);
  }

  download(text) {
    let date = new Date();
    let dateFormat = date.toLocaleDateString('pt-BR');
    let nameFile = 'numeros_' + dateFormat + '.txt';
    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', nameFile);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  formIsValid() {
    return this.formularioGerarNumeracao.valid;
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }


}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/gerar-numeracao/numeracao-caixas/numeracao-caixas.component.ts